export const ATTACHMENTS_TARGET = 'attachments';

export const CONTACT_FORM_TARGET = 'contactForm';

export const FRANCHISES_CONTACT_FORM_TARGET = 'franchisesContactForm';
